import React, { useState } from 'react';

import classnames from 'classnames';
import { SelectionState } from "../constants";
import IndeterminateCheckbox from "./IndeterminateCheckbox";

const ClusterPartTreeEntry = (
  {
    hideDecommissioned,
    allSitesContext,
    part: {
      id, name, icon, type, title, children, selectionState, selfPending, toggleSelectionState, decommissioned, initiallyExpanded
    }
  }
) => {

  const ident = `${type}-${id}`;

  const hasChildren = children.length > 0;

  const selected = selectionState();

  // In the global (AllSites) view the tree can contain every cluster, so we
  // start collapsed and let the engineer expand only the clusters they care
  // about.  For a single-component scope we keep the original behaviour of
  // auto-expanding to reveal selected items.
  const [ expanded, setExpanded ] = useState(initiallyExpanded || !hasChildren || (!allSitesContext && selected > 0));

  const classes = classnames(
    'cluster-part',
    {
      'pending': selfPending,
      'selected': selected === SelectionState.SELF_ONLY || selected === SelectionState.SELF_AND_CHILDREN,
      'text-muted': decommissioned
    }
  );

  const childrenShouldBePruned = !(expanded || selected > SelectionState.UNSELECTED);

  if (decommissioned && hideDecommissioned) {
    return null;
  } else {
    return (
      <li>
        <div className={classnames('name d-flex align-items-center gap-x-2', classes)}>
          {
            hasChildren ?
            <button
              aria-expanded={expanded}
              className={classnames('chevron-collapse-button mr-0 btn btn-sm', { 'collapsed': !expanded })}
              id={`${ident}-expand`}
              onClick={() => setExpanded(!expanded)}
              type='button'
            >
              <i
                className={classnames('text-orange fa', { 'fa-chevron-down': expanded, 'fa-chevron-right': !expanded })}
                style={{width: "14px"}}
              />
            </button>
              : null
          }
          <span
            className={`fa fa-fw ${icon}`}
            title={title || type}
          />
          <div className='form-check form-check-inline'>
            <label
              className='form-check-label'
              htmlFor={ident}
            >
              {name}
            </label>
            <IndeterminateCheckbox
              className='form-check-input'
              id={ident}
              name='associations[]'
              value={ident}
              checked={selected === SelectionState.SELF_AND_CHILDREN || selected === SelectionState.SELF_ONLY}
              indeterminate={selected === SelectionState.SOME_CHILDREN}
              onChange={toggleSelectionState}
            />
          </div>
        </div>
        {
          hasChildren && !childrenShouldBePruned ?
            <ul
              className={classnames('fa-ul', 'collapse', { 'show': expanded })}
              id={`${ident}-children`}
            >
              {
                children.map(
                  child => (
                    <ClusterPartTreeEntry
                      key={`${child.type}-${child.id}`}
                      hideDecommissioned={hideDecommissioned}
                      part={child}
                    />
                  )
                )
              }
            </ul>
            : null
        }
      </li>
    );
  }
};

export default ClusterPartTreeEntry;
